import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import { decode } from 'html-decoder';
import building from 'building.svg';
import LoadingCard from './LoadingCard';
import useSlides from '../../hooks/useSlides';
import useWindowSize from '../../hooks/useWindowSize';

export default function LoadingSlider({
  headerTitle,
  sliderType,
  is_small,
  cardWidth,
}) {
  const cardsWrapperRef = useRef(null);

  const slideCount = useSlides({
    sliderRef: cardsWrapperRef,
    cardWidth,
  });

  const { width: windowWidth } = useWindowSize();
  const isMobile = windowWidth <= 768;

  return (
    <section className="card-section-container" ref={cardsWrapperRef}>
      <aside className="card-section-header">
        <div className="header-title-container">
          <ReactSVG src={building} className="header-icon" />
          <h2 className="header-title">{decode(headerTitle)}</h2>
        </div>

        <div className="loading-text sub-title" />
      </aside>

      <div className="cards-wrapper">
        <div
          className={`cards-container ${sliderType} ${
            is_small ? 'is_small' : ''
          }`}
        >
          {[...Array(isMobile ? 6 : slideCount)].map((_, ind) => (
            <LoadingCard key={ind} card_type={sliderType} is_small={is_small} />
          ))}
          {isMobile && <div className="slider-end-padding" />}
        </div>
      </div>
    </section>
  );
}

LoadingSlider.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  sliderType: PropTypes.oneOf(['events', 'instagram', 'community', '']),
  cardWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  is_small: PropTypes.bool,
};
